import _ from "lodash";
import React from "react";
import PropTypes from "prop-types";

import SelectInputField from "./SelectInputField";

const PaymentOptionSelect = ({ name, label, required, paymentOptions, useAll = true, ...rest }) => {
  let options = [{ value: "", label: "All" }].concat(
    _.map(paymentOptions, (item) => ({ value: item.id, label: item.name }))
  );
  if (!useAll) {
    options = options.filter((item) => item.value !== "");
  }
  return (
    <SelectInputField
      name={name}
      label={label}
      options={options}
      required={required}
      filterOption={(option, inputValue) =>
        option.value === "" ||
        paymentOptions
          .filter((i) => i.name.toLowerCase().includes(inputValue?.toLowerCase()))
          .some((i) => i.id === option.value)
      }
      {...rest}
    />
  );
};

PaymentOptionSelect.defaultValues = {
  required: false,
  label: "",
  options: [],
};
PaymentOptionSelect.propTypes = {
  name: PropTypes.string.isRequired,
  required: PropTypes.bool,
  label: PropTypes.string,
  paymentOptions: PropTypes.array,
  useAll: PropTypes.bool,
};

export default PaymentOptionSelect;
